export enum ErrorMessages {
  NO_JWT = 'Missing JWT in Cookie',
}
